import { useMemo } from 'react';

import type { DecisionMaker } from 'src/app/pages/petitionDetails/shared/types';

import type { DecisionMakerAndLegislativeBody } from '../../../../hooks/dmsWithLegislativeBodies';
import { useDmsWithLegislativeBodiesConnection } from '../../../DecisionMakerSection/hooks/useDmsWithLegislativeBodiesConnection';

type Result = ModelHookResult<{
	isShown: boolean;
	count: number;
	first: { displayName: string };
	dms: DecisionMaker[] | Array<DecisionMakerAndLegislativeBody['decisionMakers'][number]>;
}>;

export const useDecisionMakers = (): Result => {
	const { data: dmsAndLBsConnection } = useDmsWithLegislativeBodiesConnection();

	const isShown = dmsAndLBsConnection.totalCount > 0;
	const count = dmsAndLBsConnection.totalCount;
	const first = useMemo(() => {
		if (dmsAndLBsConnection.totalCount > 0) {
			return dmsAndLBsConnection.decisionMakersAndLegislativeBodies[0].decisionMakers[0];
		}
		return { displayName: '' };
	}, [dmsAndLBsConnection]);

	const dms = useMemo(() => {
		const list = [];
		for (const item of dmsAndLBsConnection.decisionMakersAndLegislativeBodies) {
			for (const dm of item.decisionMakers) {
				list.push(dm);
			}
		}
		return list;
	}, [dmsAndLBsConnection]);

	const decisionMakers = useMemo(() => {
		return {
			data: {
				isShown,
				count,
				first,
				dms,
			},
		};
	}, [isShown, count, first, dms]);

	return decisionMakers;
};
